<template>
  <div v-if="error" :class="alertClass" class="mt-3">
    <i :class="iconClass"></i>
    {{ error }}
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  error: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: 'danger', // danger, warning, info, success
    validator: (value) => ['danger', 'warning', 'info', 'success'].includes(value)
  }
});

const alertClass = computed(() => {
  return `alert alert-${props.type}`;
});

const iconClass = computed(() => {
  return 'ni ni-notification-70'; // Icono de exclamación para todos los tipos
});
</script>

<style scoped>
.alert {
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.375rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: white; /* Texto blanco para todos los tipos */
}

.alert-danger {
  background-color: #dc3545;
  border-color: #dc3545;
}

.alert-warning {
  background-color: #ffc107;
  border-color: #ffc107;
}

.alert-info {
  background-color: #17a2b8;
  border-color: #17a2b8;
}

.alert-success {
  background-color: #28a745;
  border-color: #28a745;
}

.alert i {
  font-size: 1rem;
  flex-shrink: 0;
  color: white; /* Icono blanco para todos los tipos */
}
</style>